export const environment = {
    production: false,
    version: 'snapshot-d741c7df'
  };
  